<template>
  <div class="audit-form-block">
    <h5>Audit</h5>
    <ul>
      <li>Created: {{ entity.creationTime }}</li>
      <li>Updated: {{ entity.lastModificationTime }}</li>
    </ul>
  </div>
  <!-- /.audit-form-block -->
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import IAuditedEntity from "@/core/interfaces/IAuditedEntity";

export default defineComponent({
  name: "AuditFormBlock",
  props: {
    entity: {
      type: Object as PropType<IAuditedEntity>,
      required: true
    }
  }
});
</script>
